// AdapterAddTile.jsx — "Adicionar adapter custom" grid tile.

import { Plus } from 'lucide-react';

export default function AdapterAddTile({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Adicionar adapter custom"
      className="flex flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed border-apolo-borderSubtle p-3 text-apolo-textTertiary transition hover:border-apolo-accent hover:bg-apolo-surface2 hover:text-apolo-accent focus:outline-none focus:ring-2 focus:ring-apolo-accent/50"
    >
      <Plus size={20} aria-hidden="true" />
      <span className="text-xs font-medium">Adicionar adapter</span>
      <span className="text-[10px] text-apolo-textTertiary">OpenAI-compat</span>
    </button>
  );
}
